(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-carousel"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector('.ilmoitus-karuselli-wrapper');
  if (!wrapper) return;

  const track = wrapper.querySelector('.ilmoitus-karuselli-track');
  const leftBtn = wrapper.querySelector('.ilmoitus-nav.vasen');
  const rightBtn = wrapper.querySelector('.ilmoitus-nav.oikea');

  // Jos mobiilissa, ei käytetä JS-liikettä
  if (window.innerWidth < 768) return;

  let currentIndex = 0;
  const items = track.children;

  function slidesPerView() {
    return window.innerWidth >= 768 ? 2 : 1;
  }

  function updateScroll() {
    const slideWidth = items[0].offsetWidth;
    const slidesVisible = slidesPerView();
    const maxIndex = Math.max(0, items.length - slidesVisible);
    const trackWidth = track.scrollWidth;
    const wrapperWidth = wrapper.offsetWidth;

    currentIndex = Math.min(currentIndex, maxIndex);

    const buffer = 0;
    const maxTranslateX = Math.max(0, trackWidth - wrapperWidth - buffer);
    const desiredTranslateX = currentIndex * slideWidth;
    const translateX = Math.min(desiredTranslateX, maxTranslateX);

    track.style.transform = `translateX(-${translateX}px)`;

    leftBtn.style.display = currentIndex > 0 ? 'flex' : 'none';
    rightBtn.style.display = currentIndex < maxIndex ? 'flex' : 'none';
  }

  function scrollLeft() {
    if (currentIndex > 0) {
      currentIndex--;
      updateScroll();
    }
  }

  function scrollRight() {
    if (currentIndex < items.length - slidesPerView()) {
      currentIndex++;
      updateScroll();
    }
  }

  leftBtn.addEventListener('click', scrollLeft);
  rightBtn.addEventListener('click', scrollRight);
  window.addEventListener('resize', updateScroll);
  updateScroll();
});

  } catch(e) { console.error(e); }
})();
})();
